var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand cursor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0251 10.6771L16.2333 16.2206C16.0948 17.1901 15.2519 17.9209 14.2727 17.9209H8.5579C7.90549 17.9209 7.29547 17.6 6.92589 17.0623L3.4141 11.9544C3.08968 11.4822 3.14811 10.8456 3.55314 10.4408L4.11147 9.88247C4.57493 9.41901 5.32854 9.41901 5.7918 9.88247L7.32835 11.419V3.26453C7.32835 2.60915 7.86132 2.07617 8.5167 2.07617H9.02532C9.61613 2.07617 10.1101 2.50002 10.1998 3.0839L10.8486 7.30137L15.5448 8.47546C16.5329 8.72244 17.1693 9.66877 17.0251 10.6771Z",
    fill: "#5D616F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectButton);
export default __webpack_public_path__ + "static/media/object_button.1281129d71abe10bf02f37d29d6f1361.svg";
export { ForwardRef as ReactComponent };